<template>
  <div>
    <h1 class="text-2xl font-bold text-gray-900 mb-6">Idea Bank</h1>

    <IdeaCaptureInput
      :saving="saving"
      @save="handleSave"
      @split-save="handleSplitSave"
    />

    <IdeaFilterBar
      v-model:status="store.statusFilter.value"
      v-model:search="store.searchQuery.value"
      :fresh-count="store.freshCount.value"
    />

    <div v-if="store.loading.value" class="text-sm text-gray-500 italic py-8 text-center">
      Loading ideas...
    </div>

    <IdeaList
      v-else
      :ideas="store.filteredIdeas.value"
      @update="handleUpdate"
      @delete="handleDelete"
      @archive="handleArchive"
    />
  </div>
</template>

<script setup>
import { ref, onMounted, provide } from 'vue'
import { useIdeaStore } from '../../composables/useIdeaStore'
import IdeaCaptureInput from './IdeaCaptureInput.vue'
import IdeaFilterBar from './IdeaFilterBar.vue'
import IdeaList from './IdeaList.vue'

const props = defineProps({
  csrfToken: String,
})

const store = useIdeaStore(props.csrfToken)
const saving = ref(false)

provide('ideaStore', store)

onMounted(() => {
  store.loadIdeas()
})

async function handleSave(body) {
  saving.value = true
  try {
    await store.createIdea(body)
  } finally {
    saving.value = false
  }
}

async function handleSplitSave(bodies) {
  saving.value = true
  try {
    await store.batchCreate(bodies)
  } finally {
    saving.value = false
  }
}

async function handleUpdate(id, params) {
  await store.updateIdea(id, params)
}

async function handleDelete(id) {
  await store.deleteIdea(id)
}

async function handleArchive(id) {
  await store.archiveIdea(id)
}
</script>
